import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Information14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_117)'>
      <path
        d='M7 5.5C7.55228 5.5 8 5.05228 8 4.5C8 3.94772 7.55228 3.5 7 3.5C6.44772 3.5 6 3.94772 6 4.5C6 5.05228 6.44772 5.5 7 5.5Z'
        fill='currentColor'
      />
      <path d='M6.25 10.5V6.5H7.75V10.5H6.25Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 0.25C3.27208 0.25 0.25 3.27208 0.25 7C0.25 10.7279 3.27208 13.75 7 13.75C10.7279 13.75 13.75 10.7279 13.75 7C13.75 3.27208 10.7279 0.25 7 0.25ZM1.75 7C1.75 4.1005 4.1005 1.75 7 1.75C9.8995 1.75 12.25 4.1005 12.25 7C12.25 9.8995 9.8995 12.25 7 12.25C4.1005 12.25 1.75 9.8995 1.75 7Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_117'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Information14.displayName = 'Information14';
export default Information14;
